import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
} from "@angular/core";
import { NotificationService } from "app/main/services/notifications.service";
import { SocketIoService } from "app/main/services/io.service";
import { WEBSOCKET_EVENT } from "app/main/shared/enums/WebsocketEvent.enum";
import { NOTIFICATION_TYPE } from "app/main/shared/enums/Notification.enum";
import { ToastrService } from "ngx-toastr";
import { sumBy } from "lodash";
import { Router } from "@angular/router";

@Component({
  selector: "app-navbar-notification",
  templateUrl: "./navbar-notification.component.html",
  styleUrls: ["./navbar-notification.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavbarNotificationComponent implements OnInit {
  public userNotifications: Notification[] = [];
  public systemNotifications: Notification[] = [];
  public system = true;
  public unreadCount = 0;

  constructor(
    private readonly _notification: NotificationService,
    private readonly _socket: SocketIoService,
    private readonly _toastr: ToastrService,
    private readonly _cdr: ChangeDetectorRef,
    private router: Router
  ) {}

  ngOnInit(): void {
    this._notification.getAllPanel();
    this.getNotifications();
    console.log("NAVBAR NOTIFICATION");
    this._socket
      .listen(WEBSOCKET_EVENT.PUSH_NOTIFICATION)
      .subscribe((notification: Notification) => {
        this._toastr.info(notification.title);
        this._notification.getAllPanel();
        this.getNotifications();
      });
  }

  getNotifications = () => {
    this._notification
      .onNotificationsChange
      .subscribe(({ count, rows }: { count: number; rows: Notification[] }) => {
        this.unreadCount = count;
        const system = (type: NOTIFICATION_TYPE) =>
          type === NOTIFICATION_TYPE.SYSTEM ||
          type === NOTIFICATION_TYPE.SERVER_EVENT;

        this.systemNotifications = rows.filter(({ type }) => system(type));
        this.userNotifications = rows.filter(({ type }) => !system(type));
        this._cdr.markForCheck();
      });
  };

  readNotification = (notificationId: number) => {
    this._notification
      .readNotification(notificationId)
      // .subscribe(() => this.getNotifications());
  };

  goToFileArchive(event: Event) {
    event.preventDefault(); // Evita que el enlace haga una recarga completa de la página
    this.router.navigate(['/archivos-guardados']);
  }
}

export interface Notification {
  title: string;
  message: string;
  date: string;
  type: NOTIFICATION_TYPE;
  is_read: boolean;
}
